module.exports = __webpack_public_path__ + "static/media/tableGame.5953d71a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tableGame.png
// module id = 347
// module chunks = 0